import { render } from "./ManufactureSampleQuantityTable.vue?vue&type=template&id=6a1e0fb5"
import script from "./ManufactureSampleQuantityTable.vue?vue&type=script&lang=js"
export * from "./ManufactureSampleQuantityTable.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__